import type { MarchView } from "./types.js";

/** Authoritative leg endpoints, separate from the original destination retained for reports. */
export function marchLeg(march: MarchView, home: { x: number; y: number }, now: number) {
  const returning = march.state === "returning";
  const from = returning ? (march.returnLeg?.from ?? march.to) : march.from;
  const to = returning ? home : march.to;
  const startedAt = returning ? (march.returnLeg?.startedAt ?? march.arrivesAt) : march.startedAt;
  const endsAt = returning ? (march.endsAt ?? startedAt) : march.arrivesAt;
  const progress = march.state === "gathering" || march.state === "done" ? 1 : Math.max(0, Math.min(1, (now - startedAt) / Math.max(1, endsAt - startedAt)));
  return { from, to, progress, position: { x: from.x + (to.x - from.x) * progress, y: from.y + (to.y - from.y) * progress } };
}
